import { useEffect } from 'react';
import { toast } from 'react-toastify';

export default function useTokenMonitor({ onLogout }) {
  useEffect(() => {
    const checkTokenExpiry = () => {
      const expiry = parseInt(localStorage.getItem('tokenExpiry'));
      if (!expiry) return;

      const timeRemaining = expiry - Date.now();

      if (
        timeRemaining < 5 * 60 * 1000 &&
        timeRemaining > 0 &&
        !localStorage.getItem('warned')
      ) {
        toast.warn('Your session is about to expire. Please save your work.');
        localStorage.setItem('warned', 'true'); // prevent repeated warnings
      }

      if (timeRemaining <= 0) {
        localStorage.clear();
        sessionStorage.clear();
        if (onLogout) onLogout();
        window.location.href = '/login';
      }
    };

    checkTokenExpiry(); // on mount
    const interval = setInterval(checkTokenExpiry, 60 * 1000); // every 1 min
    return () => clearInterval(interval);
  }, [onLogout]);
}
